<template>
  <div class="modal-programari fixed wh100 left0 top0 flex-center z999"
       cy="modal-programari">
    <div class="main-content">
      <i @click="closeModal" class="close-btn">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="14" fill="#E5E5E7" opacity="0.8"/>
          <path d="M11 11L21 21M21 11L11 21"
                stroke="black"
                stroke-width="1.7"
                stroke-linecap="round"/>
        </svg>
      </i>
      <div class="form-content">
        <div class="left-side">
          <div class="calendar">
            <p class="section-title">Selectează data</p>
            <div class="calendar-wrapper">
              <date-picker
                @input="Handle_Update_Appointment('date', $event)"
                :inline="true"
                :lang="lang"
                :get-classes="getDateClasses"
                value-type="format"
                format="YYYY-MM-DDTHH:mm:ss.SSSZ"
                :enable-time-picker="true"
              />
              <div class="selected-day">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z" stroke="#14B8A6" stroke-width="1.5"/>
                  <path d="M12 1.5V4.5" stroke="#14B8A6" stroke-width="1.5"/>
                  <path d="M6 1.5V4.5" stroke="#14B8A6" stroke-width="1.5"/>
                  <path d="M2.25 7.5H15.75" stroke="#14B8A6" stroke-width="1.5"/>
                </svg>
                <span>{{ formattedDateLong }}</span>
              </div>
            </div>
          </div>

          <div  v-if='!existPatient'
                class="new-patient">
            <p class="section-title">Pacient</p>
            <form>
              <label class="input-name">
                Nume
                <input
                  placeholder="nume pacient"
                  cy="patient-name"
                  type="text"
                  :value="appointmentData.patient_name"
                  @input="Handle_Update_Appointment('patient_name', $event.target.value)">
              </label>
              <label class="input-name">
                Prenume
                <input
                  placeholder="prenume pacient"
                  cy="patient-name"
                  type="text"
                  :value="appointmentData.patient_surname"
                  @input="Handle_Update_Appointment('patient_surname', $event.target.value)">
              </label>

              <label class="input-phone">
                Telefon
                <div class="phone-wrapper">
                  <select v-model="selectedCountry"
                          @change="updatePhone" class="country-code">
                    <option
                      v-for="country in countries"
                      :key="country.dialCode"
                      :value="country.dialCode">
                      {{ country.name }} ({{ country.dialCode }})
                    </option>
                  </select>
                  <div class="selected-country">
                    {{ getCountryCode() }}
                  </div>
                  <input
                    v-model="phoneNumber"
                    @input="updatePhone"
                    type="tel"
                    placeholder="07xxxxxxxx"
                    class="phone-input"
                    cy="patient-phone"
                  />
                </div>
              </label>
            </form>
          </div>

        </div>

        <div class="right-side">
          <p>Detalii programare</p>
          <div class="appointment-details-wrapper">
            <div>
              <p>Ora programare</p>
              <ul>
                <li
                  :class="{ active: appointmentData.hour === ora }"
                  @click="Handle_Update_Appointment('hour', ora)"
                  v-for="ora in programareOre">
                  {{ ora }}
                </li>
              </ul>
            </div>
            <div>
              <p>Minute</p>
              <ul>
                <li
                  :class="{ active: appointmentData.minute === minute }"
                  @click="Handle_Update_Appointment('minute', minute)"
                  v-for="minute in programareMinute">
                  {{ minute }}
                </li>
              </ul>
            </div>
          </div>

          <p>Detalii durata programare</p>
          <div class="appointment-details-wrapper">
            <div>
              <p>Ora programare</p>
              <ul>
                <li
                  :class="{active: appointmentData.duration_hour === ora}"
                  @click="Handle_Update_Appointment('duration_hour', ora)" v-for="ora in durataOre">{{ ora }}</li>
              </ul>
            </div>
            <div>
              <p>Minute</p>
              <ul>
                <li
                  :class="{active: appointmentData.duration_minute === minute}"
                  @click="Handle_Update_Appointment('duration_minute', minute)" v-for="minute in durataMinute">{{ minute }}</li>
              </ul>
            </div>
          </div>

          <p>Date programare</p>
          <div class="appointment-data">
            <form>
              <div class="select-wrapper">
                <span>Tip programare</span>
                <input
                  type="text"
                  placeholder="Introduceți tip programare"
                  :value="appointmentData.type"
                  @input="Handle_Update_Appointment('type', $event.target.value)"
                />
              </div>
              <div class="select-wrapper">
                <span>Medic</span>

                <select cy="select-medic"
                        v-model="appointmentData.doctor">
                  <option value="" disabled selected>
                    Selecteaza medic
                  </option>
                  <option v-for='medic in medici'
                          :value="medic">
                    {{ medic }}
                  </option>
                </select>
              </div>
              <div class="select-wrapper">
                <span>Template folosit</span>
                <select
                  :value="appointmentData.template"
                  @change="Handle_Update_Appointment('template', $event.target.value)">
                  <option value="" disabled>Selectează template</option>
                  <option v-for="template in templates" :key="template" :value="template">
                    {{ template }}
                  </option>
                </select>

                <svg class="arrow" width="16" height="16" viewBox="0 0 20 20">
                  <path d="M5 7l5 5 5-5" fill="none" stroke="#64748B" stroke-width="2"/>
                </svg>
              </div>
              <div class="select-wrapper">
                <span>Receptioner</span>
                <select
                  @change="Handle_Update_Appointment('receptioner', $event.target.value)">
                  <option value="" disabled selected>
                    Selectează receptioner
                  </option>
                  <option v-for="receptioner in receptioners" :key="receptioner" :value="receptioner">
                    {{ receptioner }}
                  </option>
                </select>
                <svg class="arrow" width="16" height="16" viewBox="0 0 20 20">
                  <path d="M5 7l5 5 5-5" fill="none" stroke="#64748B" stroke-width="2"/>
                </svg>
              </div>
              <div class="select-language">
                <span>Selectează Limba</span>
                <div>
                  <label>
                    🇷🇴 RO
                    <input
                      @change="Handle_Update_Appointment('lang', $event.target.value)"
                      type="radio" id="ro" name="fav_language" value="RO" checked
                    >
                  </label>
                  <label>
                    🇬🇧 EN
                    <input
                      @change="Handle_Update_Appointment('lang', $event.target.value)"
                      type="radio" id="en" name="fav_language" value="EN"
                    >
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="actions flex flex-between">
        <button class="delete-btn flex-center noborder"
                cy="delete-appointment"
                v-if="appointmentData._id"
                :disabled="is_server_req"
                @click="Handle_Delete_Appointment">

          <DotSpinner v-if="is_delete_req"/>
          <span v-else>Șterge</span>
        </button>

        <div class="flex m-left-auto">

          <button class="save-btn"
                  cy="save-btn"
                  :disabled="!isFormValid || is_server_req"
                  @click="Handle_Save_Appointment">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 4.5L6.75 12.75L3 9" stroke="white" stroke-width="1.5"/>
            </svg>
            {{ save_btn_text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {mapState} from "vuex";
  import DotSpinner from '../components/loader.vue'
  import {svg} from "@/store/svg";

  export default {
    components: { DatePicker, DotSpinner },

    data () {
      return {
        lang: {
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'],
          },
          yearFormat: 'YYYY',
          monthFormat: 'MMMM',
          monthBeforeYear: true
        },

        //state
        programareOre: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],

        programareMinute: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],

        durataOre: [0, 1, 2, 3, 4, 5, 6, 7],

        durataMinute: [0, 15, 30, 45],

        templates: [
          'Notificare programare',
          'Confirmare programare',
          'Reminder programare'
        ],

        receptioners: [
          'Morar Bianca',
          'Petrean Denisa',
          'Al-Khattab Denisa',
          'Ozana Rus'
        ],

        countries: [
          { name: 'România', dialCode: '+40', code: 'RO' },
          { name: 'Moldova', dialCode: '+373', code: 'MDA' },
          { name: 'Ungaria', dialCode: '+36', code: 'HUN' },
          { name: 'Italia', dialCode: '+39', code: 'ITA' },
          { name: 'Spania', dialCode: '+34', code: 'ESP' },
          { name: 'Germania', dialCode: '+49', code: 'DEU' },
          { name: 'Franța', dialCode: '+33', code: 'FRA' },
          { name: 'Regatul Unit', dialCode: '+44', code: 'GBR' },
          { name: 'Austria', dialCode: '+43', code: 'AUT' },
          { name: 'Belgia', dialCode: '+32', code: 'BEL' },
          { name: 'Bulgaria', dialCode: '+359', code: 'BGR' },
          { name: 'Croația', dialCode: '+385', code: 'HRV' },
          { name: 'Cipru', dialCode: '+357', code: 'CYP' },
          { name: 'Cehia', dialCode: '+420', code: 'CZE' },
          { name: 'Danemarca', dialCode: '+45', code: 'DNK' },
          { name: 'Estonia', dialCode: '+372', code: 'EST' },
          { name: 'Finlanda', dialCode: '+358', code: 'FIN' },
          { name: 'Grecia', dialCode: '+30', code: 'GRC' },
          { name: 'Irlanda', dialCode: '+353', code: 'IRL' },
          { name: 'Islanda', dialCode: '+354', code: 'ISL' },
          { name: 'Letonia', dialCode: '+371', code: 'LVA' },
          { name: 'Lituania', dialCode: '+370', code: 'LTU' },
          { name: 'Luxemburg', dialCode: '+352', code: 'LUX' },
          { name: 'Malta', dialCode: '+356', code: 'MLT' },
          { name: 'Olanda', dialCode: '+31', code: 'NLD' },
          { name: 'Norvegia', dialCode: '+47', code: 'NOR' },
          { name: 'Polonia', dialCode: '+48', code: 'POL' },
          { name: 'Portugalia', dialCode: '+351', code: 'PRT' },
          { name: 'Slovacia', dialCode: '+421', code: 'SVK' },
          { name: 'Slovenia', dialCode: '+386', code: 'SVN' },
          { name: 'Suedia', dialCode: '+46', code: 'SWE' },
          { name: 'Elveția', dialCode: '+41', code: 'CHE' },
          { name: 'Turcia', dialCode: '+90', code: 'TUR' },
          { name: 'Ucraina', dialCode: '+380', code: 'UKR' },
          { name: 'Serbia', dialCode: '+381', code: 'SRB' },
          { name: 'Muntenegru', dialCode: '+382', code: 'MNE' },
          { name: 'Kosovo', dialCode: '+383', code: 'XKX' },
          { name: 'Macedonia de Nord', dialCode: '+389', code: 'MKD' },
          { name: 'Albania', dialCode: '+355', code: 'ALB' },
          { name: 'Bosnia și Herțegovina', dialCode: '+387', code: 'BIH' },
          { name: 'Belarus', dialCode: '+375', code: 'BLR' },
          { name: 'SUA', dialCode: '+1', code: 'USA' }
        ],

        existPatient: !!this.$route.params.id,

        selectedCountry: '+40',
        phoneNumber: ''
      }
    },
    computed: {
      svg() {
        return svg
      },
      ...mapState({
        pacient: 'pacient',
        medici: 'medici',
      }),
      save_btn_text () {
        return this.is_server_req ? 'Se salvează ...' : 'Salvează'
      },
      formattedDateLong () {
        const date = this.appointmentData.date
        if (!date) return ''

        const d = date instanceof Date ? date : new Date(date)

        return new Intl.DateTimeFormat('ro-RO', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(d)
      },
      appointmentData () {
        return this.$store.state.calendar.appointmentData;
      },
      is_delete_req () {
        return this.$store.state.calendar.is_delete_req;
      },
      is_server_req () {
        return this.$store.state.calendar.is_server_req;
      },
      isFormValid () {
        const data = this.appointmentData;
        return (
          data.date
          // && data.duration_hour > 0
          && data.type
          && data.doctor
          && data.receptioner
          && data.template
          // (!data.isNewPatient || (data.patientName && data.patientName.trim() !== '' && data.patientPhone && data.patientPhone.trim() !== ''))
        );
      }
    },
    methods: {
      Handle_Update_Appointment (key, value) {
        this.$store.commit('UPDATE_APPOINTMENT_DATA', { key, value });
      },
      closeModal () {
        this.$store.commit('SET_SHOW_MODAL_PROGRAMARI', false);
        this.$store.commit('RESET_APPOINTMENT_DATA');
      },
      getCountryCode () {
        const country = this.countries.find(c => c.dialCode === this.selectedCountry);
        return country ? country.code : 'ROU';
      },
      updatePhone () {
        let cleanPhone = this.phoneNumber.replace(/\s/g, '');

        if (cleanPhone.startsWith('0')) {
          cleanPhone = cleanPhone.slice(1);
        }

        const countryCodeWithoutPlus = this.selectedCountry.replace('+', '');
        if (cleanPhone.startsWith(countryCodeWithoutPlus)) {
          cleanPhone = cleanPhone.slice(countryCodeWithoutPlus.length);
        }

        const fullPhone = countryCodeWithoutPlus + cleanPhone;
        this.Handle_Update_Appointment('patient_phone', fullPhone);
      },
      Handle_Save_Appointment () {
        const is_new_patient = !this.appointmentData._id;
        const action = is_new_patient
          ? 'create_appointment_icalendar'
          : 'update_appointment_icalendar';
        this.$store.dispatch(action);
      },
      Handle_Delete_Appointment () {
        this.$store.dispatch('delete_appointment_icalendar');
      },
      getDateClasses (cellDate) {
        if (this.appointmentData?.date) {
          const selected = new Date(this.appointmentData?.date);
          if (
            cellDate.getDate() === selected.getDate() &&
            cellDate.getMonth() === selected.getMonth() &&
            cellDate.getFullYear() === selected.getFullYear()
          ) {
            return 'my-selected-date';
          }
        }
        return '';
      }
    }

  }
</script>

<style lang="less">
.modal-programari {
  background-color: rgba(0, 0, 0, .4);
  font-family: 'Roboto', sans-serif;

  .main-content {
    padding: 20px;
    background-color: white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    position: relative;
    max-height: 100vh;

    .close-btn {
      position: absolute;
      top: 8px;
      right: 12px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      svg {
        display: block;

        circle {
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }

        path {
          transition: stroke 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
      }

      &:hover {
        transform: scale(1.05);

        svg circle {
          fill: #D1D1D6;
          opacity: 1;
        }

        svg path {
          stroke: #000000;
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  .form-content {
    width: 900px;
    display: flex;
    gap: 20px;

    .section-title {
      padding-left: 15px;
      font-size: 15px;
      color: #0F172A;
      font-weight: 600;
      margin-bottom: 5px;
    }

    .left-side {
      width: 350px;
      flex-shrink: 0;

      .calendar {
        .calendar-wrapper {
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
          margin-top: 5px;

          .selected-day {
            margin: 50px 20px 18px 20px;
            height: 44px;
            padding-left: 17px;
            border: 1px solid #99F6E4;
            border-radius: 10px;
            background-color: #F0FDFA;
            display: flex;
            align-items: center;
            gap: 12px;

            span {
              color: #115E59;
              font-size: 16px;
            }
          }
        }

        .mx-datepicker-main {
          border: none;
          margin-top: 10px;

          .mx-calendar-content .cell.my-selected-date {
            background-color: #14B8A6;
            color: white;
            height: 30px;
            width: 30px;
            border-radius: 10px;
          }

          .mx-table-date {
            > thead {
              color: #64748B;
            }

            > tbody {
              color: #0F172A;

              tr td {
                height: 40px;
                width: 40px;
                font-size: 15px;

                &:hover {
                  background-color: #E0FFFC;
                  border-radius: 8px;
                }
              }
            }
          }

          .mx-icon-left, .mx-icon-right {
            color: #14B8A6;
          }

          .mx-calendar-header-label {
            pointer-events: none;

            .mx-calendar-header-label, button {
              color: #0F172A;
              font-weight: 600;
            }
          }

          .mx-calendar-panel-date {
            padding: 0 12px;
            width: 100%;
          }

          .mx-icon-double-left, .mx-icon-double-right {
            display: none;
          }
        }

        p {
          font-size: 15px;
          color: #0F172A;
          font-weight: 600;
          padding: 4px 0 0 15px;
        }
      }

      .new-patient {
        .section-title {
          margin-top: 20px;
        }

        form {
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
          padding: 23px 20px;

          .input-phone {
            display: block;
            font-size: 15px;
            color: black;

            .phone-wrapper {
              display: flex;
              position: relative;
              margin-top: 6px;
              color: #777777;

              .country-code {
                position: absolute;
                opacity: 0;
                width: 60px;
                height: 44px;
                cursor: pointer;
                z-index: 2;
              }

              .selected-country {
                width: 65px;
                height: 38px;
                border: 1px solid #99F6E4;
                border-right: none;
                border-radius: 5px 0 0 5px;
                background-color: #F7FFFD;
                font-size: 14px;
                color: #0F172A;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
                pointer-events: none;
                z-index: 1;
              }

              .phone-input {
                flex: 1;
                padding-left: 10px;
                border: 1px solid #99F6E4;
                border-radius: 0 5px 5px 0;
                background-color: #F7FFFD;
                font-size: 14px;
                color: #0F172A;
                outline: none;
                height: 38px;

                &::placeholder {
                  color: #94A3B8;
                }

                &:focus {
                  border-color: #14B8A6;
                }
              }
            }
          }

          .input-name {
            display: block;
            font-size: 15px;
            color: #777777;
            margin-bottom: 8px;

            input {
              margin-top: 6px;
              padding-left: 10px;
              border-color: #99F6E4;
              border-radius: 5px;
              background-color: #F7FFFD;
              width: 100%;
              display: block;
            }
          }

          .custom-checkbox {
            display: inline-flex;
            gap: 8px;
            align-items: center;
            cursor: pointer;
            color: black;
            font-size: 16px;
            font-weight: bold;

            input {
              position: absolute;
              opacity: 0;
              pointer-events: none;
            }
          }
        }
      }
    }

    .right-side {
      flex: 1;
      min-width: 450px;

      > p {
        padding-left: 15px;
        font-size: 15px;
        color: #0F172A;
        font-weight: 600;
        margin-bottom: 5px;

        &:nth-child(3) {
          margin-top: 20px;
        }

        &:nth-child(5) {
          margin-top: 20px;
        }
      }

      .appointment-details-wrapper {
        border: 1px solid #EBEBEB;
        border-radius: 16px;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        display: flex;
        justify-content: center;
        padding: 10px 25px;

        div {
          display: flex;
          flex-direction: column;

          &:first-child {
            margin-right: 67px;
          }

          p {
            font-size: 15px;
            color: #777777;
            padding: 0 0 8px 0;
          }

          ul {
            display: flex;
            flex-wrap: wrap;
            width: 205px;

            li {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              color: #0F172A;
              width: 40px;
              height: 40px;
              margin: 5px;
              border: 2px solid #E2E8F0;
              border-radius: 6px;
              cursor: pointer;

              &:hover {
                border: 1px solid #14B8A6;
              }

              &.active {
                color: white;
                font-weight: bold;
                background: #14B8A6;
              }
            }
          }
        }
      }

      .appointment-data {
        border: 1px solid #EBEBEB;
        border-radius: 16px;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        padding: 15px 20px;

        form {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .select-wrapper {
            flex: 1 1 calc(50% - 5px);
            min-width: 220px;
            position: relative;

            span {
              display: block;
              font-size: 15px;
              color: #777777;
              margin-bottom: 8px;
            }

            input, select {
              width: 100%;
              height: 38px;
              padding: 0 12px;
              font-size: 14px;
              color: #0F172A;
              background-color: #F7FFFD;
              border: 1px solid #99F6E4;
              border-radius: 6px;
              outline: none;
              transition: border-color 0.2s ease;
              appearance: none;

              &::placeholder {
                color: #94A3B8;
              }

              &:hover {
                border-color: #14B8A6;
              }

              &:focus {
                border-color: #14B8A6;
                background-color: #FFFFFF;
              }

              &:disabled {
                background-color: #F1F5F9;
                cursor: not-allowed;
                opacity: 0.6;
              }
            }

            select {
              cursor: pointer;
              padding-right: 36px;

              option {
                padding: 8px;

                &:disabled {
                  color: #94A3B8;
                }
              }
            }

            .arrow {
              position: absolute;
              right: 12px;
              bottom: 14px;
              pointer-events: none;
              transition: transform 0.2s ease;
            }

            &:hover .arrow {
              transform: translateY(2px);
            }
          }

          .select-language {
            flex: 1 1 calc(50% - 5px);

            span {
              display: block;
              font-size: 15px;
              color: #777777;
              margin-bottom: 8px;
            }

            > div {
              display: inline-flex;
              align-items: center;
              width: 250px;
              gap: 16px;
              height: 38px;
            }

            label {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              cursor: pointer;
              font-size: 16px;
              color: #0F172A;
              font-weight: 500;
              padding: 8px 16px;
              border: 1px solid #99F6E4;
              border-radius: 6px;
              background-color: #F7FFFD;
              transition: all 0.2s ease;
              height: 100%;
              flex: 1;

              &:hover {
                border-color: #14B8A6;
                background-color: #FFFFFF;
              }

              input[type="radio"] {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  .actions {
    margin-top: 24px;
    gap: 12px;

    button {
      padding: 13px 24px;
      cursor: pointer;
      border-radius: 6px;
      font-size: 15px;
      transition: opacity 0.1s ease-in-out;
      font-weight: bold;
    }

    .save-btn {
      display: flex;
      gap: 5px;
      align-items: center;
      background-color: #14B8A6;
      border: none;
      color: white;
      opacity: 0.8;

      &:disabled {
        background-color: #94A3B8;
        cursor: not-allowed;
        opacity: 0.5;
      }

      &:hover {
        opacity: 1;
      }
    }

    .delete-btn {
      border-radius: 4px;
      background-color: #ffa2a2;
      color: white;
      width: 99px;
      height: 44px;

      &:hover {
        background-color: #ef8585;
        color: white;
      }
    }
  }
}
</style>
